import { Directive } from "@angular/core";
import { BaseComponent, UserService, WindowService } from "@mypxplat/xplat/core";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";

@Directive()
export abstract class ForgotpasswordBaseComponent extends BaseComponent {
  public email: string;
  public done: Subject<boolean> = new Subject();
  public captcha: any;
  public emailSent: boolean;
  public success: boolean;
  public code: string;
  public newPassword: string;
  public newPassword2: string;
  public passwordPasses: boolean = false;
  public loading: boolean = false;

  constructor(
    public userService: UserService,
    private _win: WindowService,
    private _translate: TranslateService
  ) {
    super(userService);
  }
}
